import { render, staticRenderFns } from "./CostSetting.vue?vue&type=template&id=b7e21648&scoped=true&"
import script from "./CostSetting.vue?vue&type=script&lang=js&"
export * from "./CostSetting.vue?vue&type=script&lang=js&"
import style0 from "./CostSetting.vue?vue&type=style&index=0&id=b7e21648&lang=less&scoped=true&"
import style1 from "./CostSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e21648",
  null
  
)

export default component.exports